// Job: Fixed top band on the preview deploy, plus PreviewOffset that pushes the app below it.
// Why: Hosts and Barry can tell preview from prod at a glance; gated on VITE_PREVIEW_BANNER=1 so prod ships without it.
// Mounted once at the root in `src/main.tsx`. Pushes the rest of the app
// down by its height so it never overlaps content. High z-index so it
// stays visible above modals.

import { Z } from '../../ui/tokens/layers';
import type { CSSProperties } from 'react';
import { GT } from './tokens';

const ENABLED = import.meta.env.VITE_PREVIEW_BANNER === '1';

const wrap: CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0,
  zIndex: Z.banner,
  background: '#b54a26',
  color: '#ffffff',
  fontFamily: '"Inter","Helvetica Neue",system-ui,sans-serif',
  fontSize: GT.meta,
  padding: '6px 14px',
  textAlign: 'center',
  boxShadow: '0 1px 0 rgba(0,0,0,0.08)',
  pointerEvents: 'none',
};

// why: Editor and PreviewPane take the band off their full-height columns
export const PREVIEW_BANNER_HEIGHT = ENABLED ? 28 : 0;

export function PreviewBanner() {
  if (!ENABLED) return null;
  return (
    <div role="status" aria-label="Preview environment notice" style={wrap}>
      Preview, not real data
    </div>
  );
}

// Wraps the app root with the banner offset baked into a top padding so
// content never sits under the band. Drop-in inside main.tsx.
export function PreviewOffset({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ paddingTop: PREVIEW_BANNER_HEIGHT }}>
      <PreviewBanner />
      {children}
    </div>
  );
}
